import { Trans, useLingui } from "@lingui/react/macro";
import styles from "./GoSelfSignIn.module.scss";
import { useMutation } from "@tanstack/react-query";
import { generateEmployeeOtp, logoutEmployee } from "@/api/Employee";
import { useState } from "react";
import { useErrorMessageAlert } from "@/Utils/ErrorUtils";
import { Loading } from "@medoma/components/Loading/Loading";
import { useUserProfile } from "@/api/Users";
import { useDialog } from "@medoma/components/Dialog/useDialog";

export const GoSelfSignIn = () => {
  const { t } = useLingui();
  const [startCode, setStartCode] = useState<string | null>(null);
  const { displayErrorMessageAlert } = useErrorMessageAlert();
  const { employeeNumber } = useUserProfile();
  const { confirm } = useDialog();

  const generateOtp = useMutation({
    mutationFn: () => generateEmployeeOtp(employeeNumber),
    onSuccess: setStartCode,
  });

  const logout = useMutation({
    mutationFn: () => logoutEmployee(employeeNumber),
    onError: () => {
      displayErrorMessageAlert(
        t`Det gick inte att logga ut. Försök igen om en liten stund.`,
      );
    },
  });

  const requestStartCode = async () => {
    try {
      await generateOtp.mutateAsync();
    } catch {
      const logoutConfirmed = await confirm({
        title: t`Du är redan inloggad i Go på en annan enhet`,
        message: t`Vill du logga ut den enheten? Sedan kan du skapa en ny startkod.`,
        confirmLabel: t`Logga ut från enheten`,
      });
      if (logoutConfirmed) {
        logout.mutate();
      }
    }
  };

  const isPending = generateOtp.isPending || logout.isPending;

  return startCode ? (
    <span>
      <Trans>Startkod:</Trans> {startCode}
    </span>
  ) : isPending ? (
    <Loading />
  ) : (
    <button className={styles.selfSignInButton} onClick={requestStartCode}>
      <Trans>Logga in i Go</Trans>
    </button>
  );
};
